import { Injectable, Injector, NgZone } from '@angular/core'
import { ApiService } from './api.service'

@Injectable({
    providedIn: 'root'
})
export class CheckIdleService {

    private timeout: any

    private initialized = false

    private readonly IDLE_TIME = 60 * 60 * 1000 // 1 hour (ms)

    constructor (private injector: Injector, private ngZone: NgZone) { }

    startWatching () {
        if (this.initialized) {
            return
        }
        this.initialized = true

        this.resetTimer()

        // Run outside Angular for performance
        this.ngZone.runOutsideAngular(() => {
            window.addEventListener('mousemove', () => this.resetTimer())
            window.addEventListener('click', () => this.resetTimer())
            window.addEventListener('keydown', () => this.resetTimer())
            window.addEventListener('scroll', () => this.resetTimer())
        })
    }

    resetTimer () {
        clearTimeout(this.timeout)

        this.timeout = setTimeout(() => {
            this.ngZone.run(() => {
                this.logout()
            })
        }, this.IDLE_TIME)
    }

    logout () {
        clearTimeout(this.timeout)
        // Ends the server session too (best effort), clears local state, then lands on login
        this.injector.get(ApiService).logOutAndRedirect('/login?reason=expired')
    }
}
